<template>
  <div>
    <div class="headline5 mb-4">
      {{ $t(`modals.addGlobalMspPolicy.policies.edrSettings.title`) }}
    </div>
    <edr-settings-card
      v-model="localValue"
      :labels="availableLabels"
      :action-not-allowed="disabled"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, type PropType } from "vue";
import { defaultEmptyPolicies, GlobalPolicySection } from "@/constants/msp.ts";
import cloneDeep from "lodash/cloneDeep";
import type { GlobalPolicyConfig } from "@/_store/msp/global-policies/msp-global-policies.module.ts";
import { useMspDevicesStore } from "@/_store/msp/devices/msp-devices.module.ts";
import { storeToRefs } from "pinia";
import EdrSettingsCard from "@/components/edr/EdrSettingsCard.vue";

export default defineComponent({
  components: {
    EdrSettingsCard,
  },
  props: {
    data: {
      type: Object as PropType<GlobalPolicyConfig>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:data"],
  setup(props, { emit }) {
    const mspDevicesStore = useMspDevicesStore();
    const { getLabels } = mspDevicesStore;
    const { availableLabels } = storeToRefs(mspDevicesStore);

    const localValue = ref(
      cloneDeep(
        props.data[GlobalPolicySection.EDR] ?? defaultEmptyPolicies[GlobalPolicySection.EDR]
      )
    );

    watch(
      localValue,
      (newVal) => {
        emit("update:data", {
          ...props.data,
          [GlobalPolicySection.EDR]: newVal,
        });
      },
      { immediate: true, deep: true }
    );

    onMounted(async () => {
      await getLabels();
    });

    return {
      localValue,
      availableLabels,
    };
  },
});
</script>

<style scoped lang="scss"></style>
